module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"no_one_has_written_yet":"尚無用戶對此商品進行評價。","no_one_who_has_type_has_written_yet_html":"尚無{userPropertyTypeOptionName} 類型用戶對此商品進行評價。","should_write_review":"成為首位評論此商品的用戶吧！","write_review":"撰寫評論"}}')
  delete Component.options._Ctor
}
